/**
 * Scroll to the top of the page smoothly
 */
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

/**
 * Scroll to the top of the page instantly
 */
export const scrollToTopInstant = () => {
  window.scrollTo(0, 0);
};
